import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Customized,
} from "recharts";

const data = [
  { day: "Monday", value: 22 },
  { day: "Tuesday", value: 15 },
  { day: "Wednesday", value: 18 },
  { day: "Thursday", value: 20 },
  { day: "Friday", value: 17 },
  { day: "Saturday", value: 14 },
  { day: "Sunday", value: 19 },
];

const AttendanceGraph = () => {
  return (
    <div className="attendance-graph-wrapper">
      <h5>Graph</h5>

      <ResponsiveContainer width="100%" height={350}>
        <LineChart
          data={data}
          margin={{ top: 80, right: 20, left: 20, bottom: 20 }}
        >
          {/* Correct vertical grid (no horizontal lines) */}
          <CartesianGrid
            vertical={true}
            horizontal={false}
            stroke="#21598840" // ← correct color
            strokeWidth={2}
            verticalPoints={data.map((_, i) => {
              // Position vertical lines exactly under the X-axis ticks
              return `${(i + 1) * (100 / (data.length + 1))}%`;
            })}
          />

          {/* Y-axis hidden but prevents line clipping */}
          <YAxis hide axisLine={false} tickLine={false} tick={false} />

          {/* FIX: Monday & Sunday visible */}
          <XAxis
            dataKey="day"
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 12 }}
            padding={{ left: 30, right: 30 }}
          />

          {/* Orange Line */}
          <Line
            type="monotone"
            dataKey="value"
            stroke="#F98A1F"
            strokeWidth={3}
            dot={{
              r: 5,
              fill: "#F98A1F",
              stroke: "#fff",
              strokeWidth: 2,
            }}
            activeDot={false}
          />

          {/* BLUE TOP DOTS (perfect alignment) */}
          <Customized
            component={({ points }) => {
              if (!points) return null;

              const OFFSET = 35; // bigger offset so dot stays visible

              return points.map((pt, i) => {
                if (!pt) return null;

                let cy = pt.y - OFFSET;

                // Clamp inside chart (never allow dot to go above visible area)
                if (cy < 40) cy = 40; // always at least 40px from top

                return (
                  <circle
                    key={i}
                    cx={pt.x}
                    cy={cy}
                    r={7}
                    fill="#215988"
                    stroke="#215988"
                    strokeWidth={2}
                    style={{
                      filter: "drop-shadow(0 0 8px rgba(33, 89, 136, 0.5))",
                      pointerEvents: "none",
                    }}
                  />
                );
              });
            }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default AttendanceGraph;
